/**
 * A place for toast notifications
 */
namespace appn.toast {

    export function init() {
        // notifications plugin
        const shouldCreateNotifications = function($notification: JQuery<HTMLElement>) {
            return $notification && $notification.text().trim().length > 0;
        };
        const $infoNotification = $('#info');
        if (shouldCreateNotifications($infoNotification))
            appn.toast.notify(Type.info, $infoNotification.html());

        const $errorNotifications = $('#error');
        if (shouldCreateNotifications($errorNotifications))
            appn.toast.notify(Type.error, $errorNotifications.html());

        const $successNotifications = $('#success');
        if (shouldCreateNotifications($successNotifications))
            appn.toast.notify(Type.success, $successNotifications.html());
    }

    /**
     * Shows a Success, Danger, Info or Warning toast notification in the top center of the page.
     */
    export function notify(msgType: string, msgHtml: string, msgTitle?: string) {
        const options = new Options();

        // Auto dismiss of non-error notifications
        if (msgType !== Type.error) {
            const charCount = msgHtml.trim().length;
            options.timeOut = Math.max(Math.floor(charCount * 40), 3000).toString();
        }

        (window as any).toastr.options = options;

        // Separate title from message or default to msgType for title
        let title = emptyString;
        if (msgTitle)
            title = msgTitle;
        else if (msgHtml && msgHtml.containsIgnoreCase('#TITLE#')) {
            const bits = msgHtml.split('#TITLE#');
            title = bits[0];
            msgHtml = bits[1];
        } else if (msgHtml.length <= 60) {
            // its such a small message, just make it the title and kill the body
            title = msgHtml;
            msgHtml = emptyString;
        }
        else if (msgHtml.contains('\n')) {
            const [first, ...rest] = msgHtml.split('\n');
            title = first;
            msgHtml = rest.join('<br>');
        }
        else if (msgHtml.containsIgnoreCase('<br>')) {
            const [first, ...rest] = msgHtml.split('<br>');
            title = first;
            msgHtml = rest.join('<br>');
        }

        // Finally short circuit the color type if we find success in the title, better to show green than info, considering Save buttons are green too
        if (title.containsIgnoreCase('success'))
            msgType = Type.success;

        const capitalizedTitle = title.charAt(0).toUpperCase() + title.slice(1);
        (window as any).toastr[msgType](msgHtml, capitalizedTitle);
    }
    
    const redirectNoticeKey = 'appn.toast.redirectNotice';
    export function setRedirectNotice(msgType: string, msgHtml: string, msgTitle?: string) {
        appn.localStorage.setItem(redirectNoticeKey, {
            msgType, 
            msgHtml, 
            msgTitle
        });
    }
    
    export function raiseRedirectNotice() {
        const notice = appn.localStorage.getItem(redirectNoticeKey);
        if (!utils.hasValue(notice))
            return;
        
        appn.localStorage.removeItem(redirectNoticeKey);
        
        let { msgType, msgHtml, msgTitle } = notice;
        if (utils.hasValue(msgTitle) || utils.hasValue(msgHtml)) {
            if (!utils.hasValue(msgType)) 
                msgType = 'info';
            
            appn.toast.notify(msgType, msgHtml ?? appn.emptyString, msgTitle);
        }
    }
    
    appn.pubSub.subscribe(appn.pubSub.APPN_READY, function(channel: string, data: any) {
        const errorList = $('div.alert ul.form-errors li');

        if (errorList.length === 0)
            return;

        errorList.each(function(index: number, element: HTMLElement) {
            const id = $(element).attr('id');

            const child = $(`.card .card-body [id="${id}"]`);
            const card = child.closest('.card');
            const chevron = card.find('.card-btn-expand-or-collapse');
            const collapsed = chevron.find('i').hasClass('fa-chevron-down');

            if (collapsed)
                chevron.click();
        });
    });

    export class Options {
        closeButton: boolean = false;
        debug: boolean = false;
        newestOnTop: boolean = true;
        progressBar: boolean = false;
        positionClass: PositionClass = PositionClass.br;
        preventDuplicates: boolean = true;
        onclick: Function|null = null;
        showDuration: string = '300';
        hideDuration: string = '10';
        timeOut: string = '0';
        extendedTimeOut: string = '10000';
        showEasing: string = 'swing';
        hideEasing: string = 'linear';
        showMethod: string = 'fadeIn';
        hideMethod: string = 'fadeOut';

        constructor(options?: Options) {
            if (options) {
                this.closeButton = options.closeButton;
                this.debug = options.debug;
                this.newestOnTop = options.newestOnTop;
                this.progressBar = options.progressBar;
                this.positionClass = options.positionClass;
                this.preventDuplicates = options.preventDuplicates;
                this.onclick = options.onclick;
                this.showDuration = options.showDuration;
                this.hideDuration = options.hideDuration;
                this.timeOut = options.timeOut;
                this.extendedTimeOut = options.extendedTimeOut;
                this.showEasing = options.showEasing;
                this.hideEasing = options.hideEasing;
                this.showMethod = options.showMethod;
                this.hideMethod = options.hideMethod;
            }
        }
    }

    export enum PositionClass {
        tr = 'toast-top-right',
        br = 'toast-bottom-right',
        bl = 'toast-bottom-left',
        tl = 'toast-top-left',
        tf = 'toast-top-full-width',
        bf = 'toast-bottom-full-width',
        tc = 'toast-top-center',
        bc = 'toast-bottom-center'
    }

    export enum Type {
        success = 'success',
        info = 'info',
        warning = 'warning',
        error = 'error'
    }
}
